import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const resetPasswordApi = createAsyncThunk('master-user/reset-password', async ({ UserData }, { rejectWithValue }) => {
  try {
    console.log(UserData);
    const response = await fetch(
      `${ROOT_URL}/master-user/reset-password`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(UserData),
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const ResetPassword = createSlice(
  {
    name: 'ResetPassword',
    initialState,
    reducers: {},
    extraReducers: {
      [resetPasswordApi.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [resetPasswordApi.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [resetPasswordApi.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default ResetPassword;
